import type {
  ForManagerLocationDetail,
  ReportDetailRequestRequest,
  ReportFieldValuesRequestRequest,
  ReportSummaryRequestRequest,
} from "@sidegigllc/api/client";
import {
  generateReportRunMutation,
  reportDetailQuery,
  reportFieldsQuery,
  reportFieldValuesQuery,
  reportRunQuery,
  reportRunsQuery,
  savedReportsQuery as savedReportsQueryOptions,
  createSavedReportMutation,
  deleteSavedReportMutation,
  setDefaultSavedReportMutation,
  unsetDefaultSavedReportMutation,
  updateSavedReportMutation,
  reportSummaryQuery,
} from "api/queries/reportBuilder";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; runId?: string };

export const fieldsQuery = ({ location }: QueriesInput) => reportFieldsQuery({ locationId: location.id });

export const detailQuery = ({ location, request }: QueriesInput & { request: ReportDetailRequestRequest }) =>
  reportDetailQuery({ locationId: location.id, request });

export const summaryQuery = ({ location, request }: QueriesInput & { request: ReportSummaryRequestRequest }) =>
  reportSummaryQuery({ locationId: location.id, request });

export const fieldValuesQuery = ({
  location,
  request,
}: QueriesInput & { request: ReportFieldValuesRequestRequest | undefined }) =>
  reportFieldValuesQuery({ locationId: location.id, request });

export const runsQuery = ({ location }: QueriesInput) => reportRunsQuery({ locationId: location.id });

export const runQuery = ({ location, runId }: QueriesInput) => reportRunQuery({ locationId: location.id, runId });

export const generateRunMutation = ({ location }: QueriesInput) =>
  generateReportRunMutation({ locationId: location.id });

export const savedReportsQuery = ({ location }: QueriesInput) => savedReportsQueryOptions({ locationId: location.id });

export const createSavedMutation = ({ location }: QueriesInput) =>
  createSavedReportMutation({ locationId: location.id });

export const updateSavedMutation = ({ location }: QueriesInput) =>
  updateSavedReportMutation({ locationId: location.id });

export const deleteSavedMutation = ({ location }: QueriesInput) =>
  deleteSavedReportMutation({ locationId: location.id });

export const setDefaultSavedMutation = ({ location }: QueriesInput) =>
  setDefaultSavedReportMutation({ locationId: location.id });

export const unsetDefaultSavedMutation = ({ location }: QueriesInput) =>
  unsetDefaultSavedReportMutation({ locationId: location.id });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  fieldsQuery(input),
  savedReportsQuery(input),
  runsQuery(input),
  runQuery(input),
];
